export const INPUT_COLORS = {
  primary: {
    accent: 'focus:ring-primary-500 focus:border-primary-500',
    border: 'border-gray-300',
    placeholder: 'placeholder-text-gray-400',
    background: 'bg-white',
    text: 'text-inherit',
    label: 'text-gray-700',
  },
  secondary: {
    accent: 'focus:ring-white focus:border-white',
    border: 'border-white',
    placeholder: 'placeholder-white',
    background: 'bg-transparent',
    text: 'text-white',
    label: 'text-white',
  },
};
